import React from 'react';
import { StyledErrorHeader, StyledFileUploadErrorList } from './styles';
import { Banner } from "../banner";
import { defaultTranslateFn } from "../../common";
export const FileUploadErrorBanner = ({ errorMessages, errorCount, bannerStyle, translateFn = defaultTranslateFn, maxVideoFileSize }) => {
    const bannerProps = {
        iconName: 'mi-icon-alert-filled-triangle',
        bannerStyle: bannerStyle
    };
    const errorList = (React.createElement(StyledFileUploadErrorList, null, errorMessages.map((errorMessage, index) => (React.createElement("li", { key: index }, typeof errorMessage === 'string'
        ? translateFn(errorMessage, { maxVideoFileSize: maxVideoFileSize })
        : errorMessage)))));
    const headerMessage = `${errorCount} ${translateFn('Upload(s) Failed')}`;
    return (React.createElement(Banner, Object.assign({}, bannerProps),
        React.createElement(StyledErrorHeader, null, headerMessage),
        errorList));
};
//# sourceMappingURL=FileUploadErrorBanner.js.map